import React from 'react';
import { ShieldCheckIcon, WrenchIcon } from 'lucide-react';
import { CTAButton } from './CTAButton';
import { OFFER_ANCHOR, PRODUCT_IMG } from './constants';
export function Hero() {
  return <section className="bg-brand-carbon px-4 pb-4 pt-4 text-white" data-id="element-77" data-mp="9kjuoj1ugu11">
      <div className="mx-auto max-w-3xl text-center" data-id="element-78" data-mp="9ip7ey33opts">
        <h1 className="mb-2 font-display text-[25px] leading-[1.02] text-white sm:text-[44px]" data-id="element-79" data-mp="4mrt0xbedtjn">
          The Complete <span className="text-brand-yellow" data-id="element-80" data-mp="1286262e70it6">Ready-To-Use Maintenance System</span>{' '}
          for Maintenance Professionals
        </h1>
        <p className="mx-auto mb-2.5 max-w-2xl text-[13px] font-medium leading-snug text-brand-line sm:text-base" data-id="element-81" data-mp="x8jjhdfliacz">
          Stop organizing every maintenance task from scratch. Use ready-to-use maintenance
          workflows, inspection checklists and control tools to manage preventive maintenance,
          repairs and daily operations with a clearer process.{' '}
          <span className="font-bold text-white" data-id="element-82" data-mp="3814bdoempwnt">Inspect. Prevent. Maintain with confidence.</span>
        </p>

        <a href={OFFER_ANCHOR} className="mb-2.5 block cursor-pointer" aria-label="Go to the offer" data-id="element-83" data-mp="3j6fxfnpbn9cs">
          <img src={PRODUCT_IMG} alt="Maintenance Ready complete 6-in-1 system box set" className="mx-auto w-full max-w-[300px] object-contain drop-shadow-2xl transition-transform duration-150 ease-out hover:scale-[1.02] sm:max-w-[420px]" data-id="element-84" data-mp="3o5j2v997rhla" />
        </a>

        <CTAButton className="mx-auto mb-2 max-w-md" data-id="element-85" data-mp="30hrjjlp9a4ai">
          🔧 YES! I WANT THE COMPLETE SYSTEM
        </CTAButton>

        <p className="mb-1 font-cond text-sm font-bold uppercase tracking-wide text-brand-yellow sm:text-base" data-id="element-86" data-mp="35aau09sncjb3">
          Get MAINTENANCE READY™ Today
        </p>
        <div className="flex flex-wrap items-center justify-center gap-x-4 gap-y-1 text-[11px] font-semibold uppercase tracking-wide text-brand-line sm:text-xs" data-id="element-87" data-mp="2viewp0ydwx7x">
          <span className="flex items-center gap-1" data-id="element-88" data-mp="2hl9puyqujubm">
            <ShieldCheckIcon aria-hidden="true" className="h-4 w-4 text-brand-yellow" data-id="element-89" data-mp="2ljpa4uvjmolc" />
            🛡️ 7-Day Money-Back Guarantee
          </span>
          <span className="flex items-center gap-1" data-id="element-90" data-mp="s3uqhvk0f6a3">
            <WrenchIcon aria-hidden="true" className="h-4 w-4 text-brand-yellow" data-id="element-91" data-mp="na9yql90f8jc" />
            🔧 Complete 6-in-1 System
          </span>
        </div>
      </div>
    </section>;
}